import React, { useState, useEffect } from "react";
import { createFactura, getProyectos } from "../api"; // <-- tu API

const FilterTableFactura = () => {
  const [comprobantes, setComprobantes] = useState([]); // [{ comprobante, conceptos, checked }]
  const [pagina, setPagina] = useState(0);
  const [proyectos, setProyectos] = useState([]);
  useEffect(() => {
    const fetchProyectos = async () => {
      try {
        const res = await getProyectos();
        setProyectos(res.data);
      } catch (err) {
        console.error("Error al obtener proyectos:", err);
        setProyectos([]);
      }
    };

    fetchProyectos();
  }, []);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    const newData = [];

    for (const file of files) {
      const text = await file.text();
      const parser = new DOMParser();
      const xml = parser.parseFromString(text, "application/xml");

      const getAttr = (tag, attr) =>
        xml.getElementsByTagName(tag)[0]?.getAttribute(attr) || "N/A";

      const comprobanteData = {
        NombreArchivo: file.name,

        // Atributos del nodo <cfdi:Comprobante>
        Version: getAttr("cfdi:Comprobante", "Version"),
        Serie: getAttr("cfdi:Comprobante", "Serie"),
        Folio: getAttr("cfdi:Comprobante", "Folio"),
        Fecha: getAttr("cfdi:Comprobante", "Fecha"),
        FormaPago: getAttr("cfdi:Comprobante", "FormaPago"),
        CondicionesDePago: getAttr("cfdi:Comprobante", "CondicionesDePago"),
        SubTotal: getAttr("cfdi:Comprobante", "SubTotal"),
        Descuento: getAttr("cfdi:Comprobante", "Descuento"),
        Moneda: getAttr("cfdi:Comprobante", "Moneda"),
        TipoCambio: getAttr("cfdi:Comprobante", "TipoCambio"),
        Total: getAttr("cfdi:Comprobante", "Total"),
        TipoDeComprobante: getAttr("cfdi:Comprobante", "TipoDeComprobante"),
        Exportacion: getAttr("cfdi:Comprobante", "Exportacion"),
        MetodoPago: getAttr("cfdi:Comprobante", "MetodoPago"),
        LugarExpedicion: getAttr("cfdi:Comprobante", "LugarExpedicion"),
        NoCertificado: getAttr("cfdi:Comprobante", "NoCertificado"),
        Certificado: getAttr("cfdi:Comprobante", "Certificado"),
        Sello: getAttr("cfdi:Comprobante", "Sello"),

        // Atributos del nodo <cfdi:Emisor>
        Emisor_RFC: getAttr("cfdi:Emisor", "Rfc"),
        Emisor_Nombre: getAttr("cfdi:Emisor", "Nombre"),
        Emisor_RegimenFiscal: getAttr("cfdi:Emisor", "RegimenFiscal"),

        // Atributos del nodo <cfdi:Receptor>
        Receptor_RFC: getAttr("cfdi:Receptor", "Rfc"),
        Receptor_Nombre: getAttr("cfdi:Receptor", "Nombre"),
        Receptor_UsoCFDI: getAttr("cfdi:Receptor", "UsoCFDI"),
        Receptor_RegimenFiscalReceptor: getAttr("cfdi:Receptor", "RegimenFiscalReceptor"),
        Receptor_DomicilioFiscalReceptor: getAttr("cfdi:Receptor", "DomicilioFiscalReceptor"),

        // Atributos del nodo <tfd:TimbreFiscalDigital>
        UUID: getAttr("tfd:TimbreFiscalDigital", "UUID"),
        FechaTimbrado: getAttr("tfd:TimbreFiscalDigital", "FechaTimbrado"),
        RfcProvCertif: getAttr("tfd:TimbreFiscalDigital", "RfcProvCertif"),
        SelloCFD: getAttr("tfd:TimbreFiscalDigital", "SelloCFD"),
        SelloSAT: getAttr("tfd:TimbreFiscalDigital", "SelloSAT"),
        NoCertificadoSAT: getAttr("tfd:TimbreFiscalDigital", "NoCertificadoSAT"),
      };

      const conceptosElements = xml.getElementsByTagName("cfdi:Concepto");

      const conceptosData = Array.from(conceptosElements).map((el) => {
        const traslado = el.getElementsByTagName("cfdi:Traslado")[0];

        return {
          ClaveProdServ: el.getAttribute("ClaveProdServ"),
          NoIdentificacion: el.getAttribute("NoIdentificacion"),
          Cantidad: el.getAttribute("Cantidad"),
          ClaveUnidad: el.getAttribute("ClaveUnidad"),
          Unidad: el.getAttribute("Unidad"),
          Descripcion: el.getAttribute("Descripcion"),
          ValorUnitario: el.getAttribute("ValorUnitario"),
          Importe: el.getAttribute("Importe"),
          Descuento: el.getAttribute("Descuento"),
          ObjetoImp: el.getAttribute("ObjetoImp"),

          // Impuestos (solo el primer traslado si hay)
          Impuesto_Base: traslado?.getAttribute("Base") || null,
          Impuesto_Importe: traslado?.getAttribute("Importe") || null,
          Impuesto_Impuesto: traslado?.getAttribute("Impuesto") || null,
          Impuesto_TasaOCuota: traslado?.getAttribute("TasaOCuota") || null,
          Impuesto_TipoFactor: traslado?.getAttribute("TipoFactor") || null,

          proyectoId: "",
        };
      });

      newData.push({
        comprobante: comprobanteData,
        conceptos: conceptosData,
        checked: false,
      });
    }

    setComprobantes((prev) => [...prev, ...newData]);
    setPagina(0);
  };

  const handleProyectoChange = (conceptoIdx, value) => {
    const updated = [...comprobantes];
    updated[pagina].conceptos[conceptoIdx].proyectoId = value;
    setComprobantes(updated);
  };

  const toggleCheck = (index) => {
    const updated = [...comprobantes];
    updated[index].checked = !updated[index].checked;
    setComprobantes(updated);
  };

  const enviarSeleccionados = async () => {
    const seleccionados = comprobantes.filter((item) => item.checked);
    console.log("seleccionados>>>>>", seleccionados)
    try {
      console.log("factura>>>>>", seleccionados)
      await createFactura(seleccionados); // Llama a tu API
      alert("Facturas enviadas con éxito.");
    } catch (err) {
      console.error("Error al enviar:", err);
      alert("Ocurrió un error al enviar las facturas.");
    }
  };

  const actual = comprobantes[pagina];

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-center">Agregar Facturas</h1>
      <center>
      <div className="flex gap-4 flex-wrap justify-center mb-6">
        <label htmlFor="archivo" className="button-form-blue text-center cursor-pointer">
          Seleccionar XML
        </label>
        <input
          id="archivo"
          type="file"
          accept=".xml"
          multiple
          onChange={handleFileChange}
          style={{ display: "none" }}
        />

        <button
          onClick={() => {
            setComprobantes([]);
            setPagina(0);
          }}
          className="button-form-gray"
        >
          Limpiar facturas
        </button>
      </div></center>

      <hr className="mb-6" />
     {comprobantes.length > 1 && (
        <div className="mt-6 flex justify-center gap-2">
          <button
            onClick={() => setPagina(pagina - 1)}
            disabled={pagina === 0}
            className="button-form-blue"
          >
            Anterior
          </button>
          <span className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">
            {pagina + 1} / {comprobantes.length}
          </span>
          <button
            onClick={() => setPagina(pagina + 1)}
            disabled={pagina === comprobantes.length - 1}
            className="button-form-blue"
          >
            Siguiente
          </button>
        </div>
      )}
      {actual && (
        <div>
          <div className="mb-2 flex items-center justify-between">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={actual.checked}
                onChange={() => toggleCheck(pagina)}
              />
              <span className="font-semibold">
                Seleccionar factura para enviar
              </span>
            </label>
            <span className="text-sm text-gray-500">{actual.comprobante.NombreArchivo}</span>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold">Comprobante</h2>
            <table className="table">
              <tbody>
                {Object.entries(actual.comprobante).map(([key, value]) => (
                  key !== "NombreArchivo" && (
                    <tr key={key}>
                      <td className="border px-2 py-1 font-medium">{key}</td>
                      <td className="border px-2 py-1">{value}</td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <h2 className="text-xl font-semibold">Conceptos</h2>
            <table className="table">
            <thead>
              <tr>
                <th className="border px-2 py-1">Proyecto</th>
                {Object.keys(actual.conceptos[0] || {}).map((key) => (
                  key !== "proyectoId" && (
                    <th key={key} className="border px-2 py-1">{key}</th>
                  )
                ))}
              </tr>
            </thead>
            <tbody>
              {actual.conceptos.map((item, idx) => (
                <tr key={idx}>
                  <td className="border px-2 py-1">
                    <select
                      value={item.proyectoId}
                      onChange={(e) => handleProyectoChange(idx, e.target.value)}
                      className="border px-1 py-1 rounded"
                    >
                      <option value="">Selecciona</option>
                      {proyectos.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.cliente_proveedor_nombre}-{p.titulo}
                        </option>
                      ))}
                    </select>
                  </td>
                  {Object.entries(item).map(([key, val]) =>
                    key !== "proyectoId" ? (
                      <td key={key} className="border px-2 py-1">{val}</td>
                    ) : null
                  )}
                </tr>
              ))}
            </tbody>
            </table>
          </div>
        </div>
      )}

 

      {comprobantes.some((c) => c.checked) && (
        <div className="mt-8 text-center">
          <button
            onClick={enviarSeleccionados}
            className="button-form-blue"
          >
            Enviar seleccionados
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterTableFactura;
